<template>
  <div class="exponencial">
    <div class="row">
      <h5 class="disparador" data-disparador="conteudo_exponencial">
        (se for exponencial)
        <i class="material-icons rotate">arrow_drop_down</i>
      </h5>
    </div>
    <div class="conteudo" id="conteudo_exponencial" style="display: block;">
      <div class="form-group">
        <label for="exampleInputEmail1">q:</label>
        <input
          type="number"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder
        />
        <small id="emailHelp" class="form-text text-muted">Informações para o campo.</small>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name:"exponencial"
}
</script>